<!--  <button class="btn" (click)="EventClick('success')">Кнопка 1</button>-->
<!--  <button class="btn" (click)="EventClick('error')">Кнопка 2</button>-->
<!--  <button class="btn" (click)="EventClick()">Кнопка 3</button>-->
<!--  <button class="btn" disabled>Кнопка 4</button>-->
<!--  <div class="form-group">-->
<!--    <label class="form-label">Название</label>-->
<!--    <input type="text" class="form-input" placeholder="Введите текст">-->
<!--  </div>-->
<!--  <div class="form-group">-->
<!--    <label class="form-label">Название</label>-->
<!--    <ng-select-->
<!--      class="my-select"-->
<!--      [items]="testList"-->
<!--      bindLabel="name"-->
<!--      bindValue="value"-->
<!--      [placeholder]="'Не выбрано'"-->
<!--      [notFoundText]="'Не найдено'"-->
<!--      [closeOnSelect]="true"-->
<!--      [searchable]="false"-->
<!--      [clearable]="false"-->
<!--    ></ng-select>-->
<!--  </div>-->
<router-outlet></router-outlet>

<!--<div style="position: fixed; right: 20px; top: 20px;">
    @if (IsWSconnected()) { <p>WS Connected</p>} @else { <p>WS NOT Connected</p>}
  </div>-->
